var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCategoryBlogFrame = function SvgCategoryBlogFrame(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 60,
    viewBox: "0 0 132 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5376_17615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.197 96.7717H100.493L121.963 0H131.667L110.197 96.7717Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5686 96.7717H78.8643L100.339 0H110.044L88.5686 96.7717Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9475 96.7717H57.2432L78.7183 0H88.4227L66.9475 96.7717Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3225 96.7717H35.6182L57.0884 0H66.7928L45.3225 96.7717Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7014 96.7717H13.9971L35.4673 0H45.1717L23.7014 96.7717Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07664 96.7717H-7.62769L13.8475 0H23.5518L2.07664 96.7717Z",
    fill: "#E98EAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5376_17615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 60,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCategoryBlogFrame);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMyIiBoZWlnaHQ9IjYwIiB2aWV3Qm94PSIwIDAgMTMyIDYwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNTM3Nl8xNzYxNSkiPgo8cGF0aCBkPSJNMTEwLjE5NyA5Ni43NzE3SDEwMC40OTNMMTIxLjk2MyAwSDEzMS42NjdMMTEwLjE5NyA5Ni43NzE3WiIgZmlsbD0iI0U5OEVBQSIvPgo8cGF0aCBkPSJNODguNTY4NiA5Ni43NzE3SDc4Ljg2NDNMMTAwLjMzOSAwSDExMC4wNDRMODguNTY4NiA5Ni43NzE3WiIgZmlsbD0iI0U5OEVBQSIvPgo8cGF0aCBkPSJNNjYuOTQ3NSA5Ni43NzE3SDU3LjI0MzJMNzguNzE4MyAwSDg4LjQyMjdMNjYuOTQ3NSA5Ni43NzE3WiIgZmlsbD0iI0U5OEVBQSIvPgo8cGF0aCBkPSJNNDUuMzIyNSA5Ni43NzE3SDM1LjYxODJMNTcuMDg4NCAwSDY2Ljc5MjhMNDUuMzIyNSA5Ni43NzE3WiIgZmlsbD0iI0U5OEVBQSIvPgo8cGF0aCBkPSJNMjMuNzAxNCA5Ni43NzE3SDEzLjk5NzFMMzUuNDY3MyAwSDQ1LjE3MTdMMjMuNzAxNCA5Ni43NzE3WiIgZmlsbD0iI0U5OEVBQSIvPgo8cGF0aCBkPSJNMi4wNzY2NCA5Ni43NzE3SC03LjYyNzY5TDEzLjg0NzUgMEgyMy41NTE4TDIuMDc2NjQgOTYuNzcxN1oiIGZpbGw9IiNFOThFQUEiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF81Mzc2XzE3NjE1Ij4KPHJlY3Qgd2lkdGg9IjEzMiIgaGVpZ2h0PSI2MCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";